const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const staggerSelectors = [
  '.koketa-collection-card',
  '.koketa-product-card',
  '.koketa-review',
  '.koketa-location__panel',
  '.product-grid__item'
];

const prepareSection = (section) => {
  const children = section.querySelectorAll(staggerSelectors.join(','));
  children.forEach((child, index) => {
    child.dataset.koketaRevealItem = '';
    child.style.setProperty('--koketa-reveal-order', index % 8);
  });
};

document.querySelectorAll('[data-koketa-reveal]').forEach(prepareSection);

if (reduceMotion.matches || !('IntersectionObserver' in window)) {
  document.querySelectorAll('[data-koketa-reveal]').forEach((element) => element.classList.add('is-visible'));
} else {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        entry.target.querySelectorAll('[data-koketa-reveal-item]').forEach((child) => child.classList.add('is-visible'));
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  document.querySelectorAll('[data-koketa-reveal]').forEach((element) => {
    observer.observe(element);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.('[data-koketa-reveal]') || event.target.closest?.('[data-koketa-reveal]');
    if (!section) return;
    prepareSection(section);
    observer.observe(section);
  });
}

const syncPageVisibility = () => {
  document.documentElement.classList.toggle('is-page-hidden', document.hidden);
};

document.addEventListener('visibilitychange', syncPageVisibility);
syncPageVisibility();

const prepareAutoLoops = (root = document) => {
  const loops = root.querySelectorAll?.('[data-koketa-auto-loop]') || [];

  if (reduceMotion.matches || !('IntersectionObserver' in window)) {
    loops.forEach((loop) => loop.classList.remove('is-loop-visible'));
    return;
  }

  const loopObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-loop-visible', entry.isIntersecting && !document.hidden);
      });
    },
    { threshold: 0.05 }
  );

  loops.forEach((loop) => loopObserver.observe(loop));
};

prepareAutoLoops();

document.addEventListener('shopify:section:load', (event) => {
  prepareAutoLoops(event.target);
});
